import { addDays, DisplayDate } from 'owa-datetime';

export default function serviceFriendlyEndDateForAllDay(end: DisplayDate): DisplayDate {
    // Within the compose form 1 day is removed from the end time for all day items for
    // ease of display to users.
    // When the event leaves the compose form we need reverse this by add one day back
    // See friendlyEndDateForAllDay for more details
    return addDays(end, 1);
}
